<template>
  <motlet :options="motletOptions">
    <template #content="{ props }">
      <!-- eslint-disable-next-line prettier/prettier -->
      <line-double-stack
        :system="system"
        :items="nodes"
        :values="values"
        :split="split"
        :y-axis-names="yAxisNames"
        :tooltip-contents="tooltipContents"
        :motlet="props.motlet"
        :contextmenu="onContextmenuChart"
      />
    </template>
    <template #menu>
      <contextmenu :options="contextmenuParam"></contextmenu>
    </template>
  </motlet>
</template>

<script>
import instanceable from './mixins/instanceable';
import contextmenuable from './mixins/contextmenuable';
import LineDoubleStack from '../chart/LineDoubleStack.vue';
import { api } from '../../../../api/common/instances';

export default {
  mixins: [instanceable, contextmenuable],
  components: {
    LineDoubleStack,
  },
  data() {
    return {
      motletOptions: {
        id: 'overview/system/java/HttpSession',
        title: 'Http Session',
        zoom: {
          use: true,
          active: false,
        },
      },
      messageName: 'rawJavaHttpSssn',
      messageFields: ['stime'],
      dataInterval: 15 * 1000, // db data 시간 간격
      values: [],
      split: {},
      recieve: {},
      yAxisNames: ['count'],
      tooltipContents: [{ name: 'Session', column: 'count' }],
      contextmenuUrl: '/views/detailview/java/ut',
    };
  },
  watch: {
    nodes: {
      handler: 'changeNodesHandler',
    },
  },
  methods: {
    wsBufferedDataHandler(key, responses, every) {
      responses.forEach(response => {
        const last = response.length ? response[response.length - 1] : { data: [], ctime: '', empty: true };
        every(key, last.data, last.ctime, last.empty);
      });
    },
    wsDataHandler(key, response, ctime, empty) {
      const count = empty ? 0 : response.length;
      if (!response.length) {
        const stime = new Date().getTime();
        response = [
          {
            ctime: stime,
            stime,
          },
        ];
      }
      const stime = response[0].stime ? parseInt(response[0].stime) : ctime;
      this.split = {
        id: key.instId,
        ctime: parseInt(ctime),
        stime: stime - (stime % this.dataInterval), // db 데이터 간격 기준으로 실시간 데이터를 근사값으로 보정
        count,
      };
    },
    sendMessage() {
      // const messages = this.nodes.map(node => ({
      //   key: { name: this.messageName, sstmId: node.systemId, instId: node.instanceId, nodeId: node.id },
      //   fields: this.messageFields,
      // }));
      // this.wsSendMessage(messages);
      this.$websocket.realtime.send({
        requests: this.nodes.map(node => ({
          key: { name: this.messageName, sstmId: node.systemId, instId: node.instanceId, nodeId: node.id },
          fields: this.messageFields,
          handler: {
            buffer: this.wsBufferedDataHandler,
            every: this.wsDataHandler,
          },
        })),
      });
    },
    async allDay() {
      const response = ((await api.get(`/motlet-data/chart/day-all?sstmId=${this.system.id}&motletCode=C_JAVA_HTTP_SESS`)) || {}).data;
      this.values = response.map(value => ({
        id: value.key.nodeId,
        left: value.data,
        right: value.yesterData,
      }));
    },
    initialize() {
      // websoket message init
      this.wsRequestMessages = {};
    },
    changeNodesHandler() {
      this.initialize();
      this.sendMessage();
      this.allDay();
    },
  },
};
</script>
